import { render, staticRenderFns } from "./channelManagement.vue?vue&type=template&id=06560c4f&scoped=true"
import script from "./channelManagement.vue?vue&type=script&lang=js"
export * from "./channelManagement.vue?vue&type=script&lang=js"
import style0 from "./channelManagement.vue?vue&type=style&index=0&id=06560c4f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06560c4f",
  null
  
)

export default component.exports